export default {
  "Audio Compressor": "Audio Compressor",
  "HitPaw Online Audio Compressor": "HitPaw Online Audio Compressor",
  "Reduce audio file size online without quality loss.": "Verklein online de grootte van uw audiobestand zonder kwaliteitsverlies.",
  "Compress": "Comprimeren",
  "Compressing": "Comprimeren",
  "Compressed Successfully": "Succesvol gecomprimeerd",
  "Compress New": "Comprimeren Nieuw",
  "Compression is complete": "Comprimeren is voltooid",
  "Compression failed": "Comprimeren mislukt",
  "Quality": "Kwaliteit",
  "Format": "Formaat",
  "Add file": "Bestand toevoegen",
  "Output Settings": "Uitvoerinstellingen",

};
